import axios, { AxiosRequestConfig } from "axios";

import { FormState } from "../components/appData.slice";

import { ApiError } from "./error";

export async function loadAppData(): Promise<FormState> {
  const config: AxiosRequestConfig = {
    method: "get",
    url: "./appData.json",
    headers: {
      "Content-Type": "application/json",
    },
    responseType: "json",
  };

  try {
    const data = await axios(config);

    return data.data;
  } catch (error) {
    throw new ApiError(error.message);
  }
}
